export default __webpack_public_path__ + "static/media/br.0195f143.svg";